// component/ScrollToTop/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll window to top whenever route path changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto", // change to "smooth" if you want animation
    });

    // Extra safety in case scrolling is attached to <html> / <body>
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
